// TODO: refactor
import g from "./globals";
import { isHome, isHomeMobile } from "./helpers";
import api from "../utils/api";

const zara = window.zara;

export const getAnalyticsByProduct = (product, action, origin = g.categoryName, type = "image") => {
  if (g.editMode) return null;
  if (!action) {
    action = type === "image" ? "Ver_producto_imagen" : "Ver Bundle";
    if (zara && zara.appConfig) {
      action = type === "image" ? "image" : "text";
    }
  }
  const eventData = {
    action,
    label: product.detail.reference,
    category: g.categoryId,
    origin,
  };
  eventData.eec = {
    type: "click",
    src: {
      listType: "GRID",
      listName: product.listName || g.categoryName,
      pos: product.sequence,
    },
    dest: {
      productRef: product.detail.reference,
      productName: product.id,
      isBundle: product.type === "Bundle",
    },
  };
  if (product.type !== "Bundle") {
    eventData.eec.dest.colorCode = product.detail.colors[0].id;
    eventData.eec.dest.stylingId = product.detail.colors[0].stylingId;
    eventData.eec.dest.price = product.price;
    eventData.eec.dest.section = product.section;
    eventData.eec.dest.family = product.familyName;
    eventData.eec.dest.subfamily = product.subfamilyName;
  }
  return eventData;
};

/* eslint-disable max-statements */
export const getAnalyticsByAttr = (layer = {}, dataAttrs = {}, i = 0, action, type = "image") => {
  if (g.editMode) return null;
  let analytic;
  // PRODUCTS
  if (dataAttrs["data-product"]) {
    const productId = dataAttrs["data-product"];
    const products = g.products.products;
    if (!products) return null;
    const product = products.find(x => x.id === productId);
    if (product) {
      if (!action) {
        action = type === "image" ? "Ver_producto_imagen" : "Ver Bundle";
      }
      analytic = {
        action,
        label: product.detail.reference,
      };
      if (product.type !== "Bundle") {
        analytic.eec = getAnalyticsByProduct(product);
      }
    }
  }
  // CATS
  // is layer or img or video?
  const src = layer.sources
    ? layer.sources[layer.sources.portrait ? "portrait" : "landscape"].src
    : layer.attrs
    ? layer.attrs.src
    : layer.src;
  const html = document.querySelector("html").id;

  let root;
  let pathSplit;
  let path;
  if (isHomeMobile() && layer.module === "Video") {
    root = src.replace(g.videoContent, "");
    pathSplit = root.split("/").filter(x => x !== "");
    path = `${pathSplit[0]}/spots/${pathSplit[3]}/${pathSplit[4]}`;
    analytic = {
      origin: isHome() ? "BANNER_HOME" : html,
      category: isHome() ? "Home" : html,
      action: action || "Click_banner",
      eec: {
        bannerId: path,
        name: pathSplit[3],
        position: i + 1,
        creative: dataAttrs["data-category"],
      },
    };
  } else if (src) {
    root = src.replace(g.imageDir, "");
    pathSplit = root.split("/").filter(x => x !== "");
    pathSplit.pop();
    path = `${pathSplit[0]}/${pathSplit[1]}/${pathSplit[2]}/${pathSplit[3]}`;
    analytic = {
      origin: isHome() ? "BANNER_HOME" : html,
      category: isHome() ? "Home" : html,
      action: action || "Click_banner",
      eec: {
        bannerId: path,
        name: pathSplit[2],
        position: i + 1,
        creative: dataAttrs["data-category"],
      },
    };
  } else if (layer && layer.module === "Video" && layer.config && layer.config.poster && layer.config.poster.length > 1) {
    root = layer.config.poster.replace(g.imageDir, "");
    pathSplit = root.split("/").filter(x => x !== "");
    pathSplit.pop();
    path = pathSplit.join("/");
    analytic = {
      origin: isHome() ? "BANNER_HOME" : html,
      category: isHome() ? "Home" : html,
      action: action || "Click_banner",
      eec: {
        bannerId: path,
        name: pathSplit[2],
        position: i + 1,
        creative: dataAttrs["data-category"],
      },
    };
  }
  return analytic;
};

export const getAnalyticsByLook = (layer, dataAttrs, pos = 0, action, type = "image") => {
  if (g.editMode) return null;
  action = type === "image" ? "Ver_producto_imagen" : "Ver Bundle";
  if (zara && zara.appConfig) {
    action = type === "image" ? "image" : "text";
  }

  const productId = dataAttrs["data-product"];
  const products = g.products.products;
  if (!products) return null;
  const product = products.find(x => x.id === productId);
  if (!product) return null;
  return {
    action,
    label: product.detail.reference,
    eec: {
      type: "click",
      dest: {
        productRef: product.detail.reference,
        productName: product.id,
        isBundle: true,
      },
      src: {
        listType: "GRID",
        listName: product.listName || g.categoryName,
        pos: parseInt(dataAttrs["data-product-idx"] || pos, 10),
      },
    },
  };
};

export const getProductAnalytics = ({ product, position }) => {
  const isBundle = product.bundleSummaries || product.bundleProducts || product.type?.toLowerCase() === "bundle";
  const productInfo = {
    brand: product.brand?.brandGroupCode || "zara",
    colorCode: product.colorInfo?.mainColorHexCode || product.detail?.colors?.[0]?.id,
    family: product.familyName || "",
    isBundle,
    price: product.price,
    productName: product.name,
    productRef: product.detail?.reference,
    section: product.sectionName,
    stylingId: product.detail?.colors?.[0]?.stylingId,
    subfamily: product.subfamilyName || "",
  };
  const viewInfo = {
    blockLayout: null,
    imageView: isBundle ? "LOOK VIEW" : "PRODUCT VIEW",
    listType: "GRID",
    sectionType: g.products?.productGroup?.type || "",
    zoomLevel: null,
  };
  const impression = {
    ...productInfo,
    ...viewInfo,
    position,
  };
  const click = {
    dest: {
      catGroupId: g.categoryId,
      catIdentifier: g.categoryName,
      ...productInfo,
    },
    src: {
      ...viewInfo,
      listName: g.categoryName,
      pos: position,
    },
  };
  return { impression, click };
};

export const sendProductAnalytics = (event, productsData) => {
  const data = {
    event_name: event,
  };
  if (event === "PRODUCT_IMPRESSION") {
    if (productsData.length > 10) {
      const chunks = productsData.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / 10);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
      }, []);
      chunks.map(chunk => {
        api.mktTrigger("MKT_EVENT", { ...data, products: chunk });
      });
    } else {
      data.products = productsData;
      api.mktTrigger("MKT_EVENT", data);
    }
  } else {
    const { dest, src } = productsData;
    data.dest = dest;
    data.src = src;
    api.mktTrigger("MKT_EVENT", data);
  }
};

export const getAnalyticsSpot = (m, k, sectionName = "") => {
  let img;
  let analytics = null;
  let root = null;
  let video = false;
  if (m.contents instanceof Array) {
    img = m.contents.find(x => x.module === "Img");
    if (img) {
      root = img.sources.portrait.src.replace(g.imageDir, "");
    }
    video = m.contents.find(x => x.module === "Video");
    if (video) {
      root = video.sources.portrait.src.replace(g.videoContent, "");
    }
  }
  if (img || video) {
    // TODO: refactor sacar de los dataAttr

    const pathSplit = root.split("/").filter(x => x !== "");
    pathSplit.pop();
    const path = `${pathSplit[1]}/${pathSplit[2]}/${pathSplit[3]}`;

    const category = isHome() ? `Home_${sectionName.toLowerCase()}` : "Subhome";

    const position = k + 1;
    analytics = {
      category,
      action: "Banner_impression",
      eec: {
        bannerId: `${path}-${video ? "video-" : ""}${sectionName.toLowerCase()}-${position}`,
        name: video ? `${pathSplit[3]}/video` : `${pathSplit[2]}/${pathSplit[3]}`,
        position,
        creative: video ? video.dataAttrs["data-category"] : img.dataAttrs["data-category"],
      },
    };
    return analytics;
  }
  return null;
};
